import React from 'react'
import TaskMini from "./TaskMini"
import useFormApi from "../../../cmn/docAutomation/useFormApi"
import * as fn from '../../../../helper/uiFunctions';

const TaskDashImageRow = (props) => {
    const { formObject, viewData, rowKey, dashRowId } = props;
    const [popupData, setPopupData] = React.useState(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const dashRow = React.useRef();

    let formApi = useFormApi();

    const resetPopupData = () => {
        setPopupData(null);
    }

    React.useEffect(resetPopupData,[viewData,rowKey]);

    if (!viewData)
        return (null);

        
    // console.log("taskRow",viewData);
    //let data = viewData.childRows[0].rowValues;
    const url = fn.getShowDocumentLink(viewData.dataList.valLDT, viewData.rId, "", 1, viewData.dataList.module, viewData.dataList.view);

    const urlTarget = viewData.dataList.windowTarget ? viewData.dataList.windowTarget : "_blank";

    const getStyle = () => {
        if (viewData.dataList.recordBarStyle !== "") {
            //alert(data.recordBarContainer.dataList.colCssStyle)
            return JSON.parse(viewData.dataList.recordBarStyle)
        }
        else {
            return {backgroundColor: "#d4dbe5", color: "#334155"};
        }
    }

    const loadPopupData = () => {
        let customAction = {
            actionId: "show",
            actionName: "dashComp",
            actionParam: {
                actionType: "",
                dshv_rowId: dashRowId,
                tdoctyid: viewData.dataList.valLDT,
                elementId: viewData.rId,
                hvCompDocTypeName: "Dashboard",
                sview: "D",
                vreload: 0,
                dshs_popup: 1
            },
            containerKey: "custom",
            onSuccess: onSuccess
        };

        formApi.runGenericAction(customAction, "dashComp", viewData, viewData.headerRows, { masterKeys: formObject.masterKeys }, "", "DashViews", 0, onSuccess);
    }

    const onRowHover = () => {
        // console.log("dash onRowHover")
        if (!popupData) {
            loadPopupData();
        }
        setIsOpen(true);
    }

    const renderDashPopup = () => {
        //console.log("dash renderDashPopup", isOpen && popupData != null);
        if (isOpen && popupData != null) {
            return (
                <TaskMini viewData={popupData} anchorRef={dashRow} />
            )
        }
        else {
            return (null)
        }
    }

    const hidePopup = () => {
        // console.log("dash hidePopup", viewData.dataList.taskTitle)
        setIsOpen(false);
    }

    const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
        setPopupData(response.mainViewData);
    }

    return (
        <div className="uiRecordContainer">
            <a href={url} target={urlTarget}>
                <div className="uiFlexBox uiTaskDashImageBody">
                    <div className={`uiBarImage ${viewData?.rowValues?.taskImage?.dataList.isHid !== "1" ? "" : "uiBarImageEmpty"}`}>
                        {viewData?.rowValues?.taskImage?.dataList.isHid !== "1" ? (
                            <img alt="" height={"100%"} width="100%" src={viewData.rowValues.taskImage.dataList.src} />
                        ) : null}
                    </div>
                    <div className="uiBarInfo">
                        <div className="uiTaskDashImageContent">
                            <div className="uiTaskDashImageTitle">
                                <span>{viewData.dataList.taskTitle}</span>
                            </div>
                            <div className="uiTaskDashImageMeta">
                                {viewData.dataList.taskSubTitle ? (
                                    <span className="uiTaskDashImageChip" style={getStyle()}>
                                        {viewData.dataList.taskSubTitle}
                                    </span>
                                ) : null}
                                <span
                                    ref={dashRow}
                                    className={`uiTaskDashImageChip uiTaskDashImagePriorityChip show-popup ${viewData.dataList.taskPriorityStyle}`}
                                    onMouseLeave={hidePopup}
                                    onMouseOver={onRowHover}
                                >
                                    {viewData.dataList.taskPriority}
                                </span>
                                {renderDashPopup()}
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    )
}

export default TaskDashImageRow
